import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck } from "@phosphor-icons/react";
import { fmtMoney } from "@/lib/api";

export default function EmitirNCDialog({
  ncPrompt, ncMotivo, setNcMotivo, ncEmitting, onCancel, onEmit,
}) {
  return (
    <AlertDialog
      open={!!ncPrompt}
      onOpenChange={(v) => { if (!v && !ncEmitting) onCancel(); }}
    >
      <AlertDialogContent className="max-w-lg" data-testid="nc-prompt-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading flex items-center gap-2">
            <ShieldCheck size={18} weight="fill" className="text-amber-600" />
            Factura con CAE — Emitir Nota de Crédito
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-[13px]">
              <div className="border border-amber-200 rounded-sm bg-amber-50/60 p-3 text-[12px]">
                <div className="font-mono">
                  <span className="font-semibold">{ncPrompt?.factura?.tipo_comprobante} {ncPrompt?.factura?.numero}</span>
                  {" · "}
                  <span>{ncPrompt?.factura?.contraparte_nombre}</span>
                </div>
                <div className="mt-1 font-mono text-[11px] text-[#666]">
                  CAE: {ncPrompt?.factura?.cae} · Total: {fmtMoney(ncPrompt?.factura?.total || 0)}
                </div>
              </div>
              <p>
                Esta factura ya fue autorizada en AFIP y <span className="font-semibold">no puede eliminarse</span>.
                Vamos a emitir una <span className="font-semibold">
                  {ncPrompt?.factura?.tipo_comprobante === "FACTURA A" ? "Nota de Crédito A" :
                   ncPrompt?.factura?.tipo_comprobante === "FACTURA B" ? "Nota de Crédito B" :
                   ncPrompt?.factura?.tipo_comprobante === "FACTURA C" ? "Nota de Crédito C" : "Nota de Crédito"}
                </span> asociada, que anulará el saldo del cliente. Ambos comprobantes quedan registrados.
              </p>
              <div>
                <Label className="text-[11px] uppercase font-mono tracking-widest text-[#666]">Motivo (opcional)</Label>
                <Input
                  data-testid="nc-motivo-input"
                  className="rounded-sm mt-1 font-mono text-[12px]"
                  placeholder="Ej: Error en el precio unitario"
                  value={ncMotivo}
                  onChange={(e) => setNcMotivo(e.target.value)}
                  disabled={ncEmitting}
                />
              </div>
              <p className="text-[11px] text-[#666] font-mono">
                Se asigna Nº y CAE en AFIP automáticamente. Podés descargar el PDF luego.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={ncEmitting} className="rounded-sm">Cancelar</AlertDialogCancel>
          <AlertDialogAction
            data-testid="nc-emit-button"
            onClick={(e) => { e.preventDefault(); onEmit(); }}
            disabled={ncEmitting}
            className="rounded-sm bg-[#6B1F24] hover:bg-[#5a1a1f]"
          >
            {ncEmitting ? "Emitiendo NC en AFIP…" : "Emitir Nota de Crédito"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
